<template>
  <div
    class="navbar-item is-hidden-tablet-only is-hidden-desktop-only"
    v-if="isUser"
  >
    <a
      class="nav-menu-item nav-cazana"
      @click="switchBranch('button')"
      data-test-id="branch-switch-button"
    >
      <strong>{{ branchName }}</strong>
      <span class="icon">
        <i class="fas fa-exchange exchange-icon-color" />
      </span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import truncate from 'truncate'
export default {
  name: 'AppHeaderEndSwitch',
  computed: {
    ...mapGetters('auth', ['isUser', 'branch']),
    branchName() {
      const length = this.$experian ? 18 : 40
      return truncate(this.branch.name, length)
    }
  },
  methods: {
    track(action) {
      this.$mxp.track(`app_header_${action}`)
    },
    switchBranch(source) {
      this.track(`open_switch_branch_modal${source}`)
      this.$modal.open('account/AccountSwitch')
    }
  }
}
</script>

<style lang="sass" scoped>
.nav-cazana
  color: $change-branch-text !important

.exchange-icon-color
  color: $exchange-icon-color !important
</style>
